import { Route } from "react-router-dom";
import jsonServerProvider from "ra-data-json-server";

import { Admin, CustomRoutes, Resource } from "react-admin";
import { AnalyticsDashboard } from "./resources/analytics/AnalyticsDashboard";
import { ChannelCreate } from "./resources/channels/ChannelCreate";
import { ChannelEdit } from "./resources/channels/ChannelEdit";
import { ChannelShow } from "./resources/channels/ChannelShow";
import { Layout } from "./layout/Layout";
import { LoginPage } from "./LoginPage";
import { LogoutPage } from "./LogoutPage";
import { MissionCreate } from "./resources/missions/MissionCreate";
import { MissionList } from "./resources/missions/MissionList";
import { MissionShow } from "./resources/missions/MissionShow";
import { NyuTheme } from "./layout/NyuTheme";
import { OrganCreate } from "./resources/organs/OrganCreate";
import { OrganEdit } from "./resources/organs/OrganEdit";
import { OrganEventCreate } from "./resources/organ_events/OrganEventCreate";
import { OrganEventEdit } from "./resources/organ_events/OrganEventEdit";
import { OrganList } from "./resources/organs/OrganList";
import { OrganShow } from "./resources/organs/OrganShow";
import { OrganTeamCreate } from "./resources/organ_teams/OrganTeamCreate";
import { TeamCreate } from "./resources/teams/TeamCreate";
import { TeamEdit } from "./resources/teams/TeamEdit";
import { TeamList } from "./resources/teams/TeamList";
import { TeamShow } from "./resources/teams/TeamShow";
import { TeamUserCreate } from "./resources/team_users/TeamUserCreate";
import { UserCreate } from "./resources/users/UserCreate";
import { UserEdit } from "./resources/users/UserEdit";
import { UserList } from "./resources/users/UserList";
import { UserShow } from "./resources/users/UserShow";
import { authProvider } from "./authProvider";
import FavoriteIcon from "@mui/icons-material/Favorite";
import GroupsIcon from "@mui/icons-material/Groups";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import PersonIcon from "@mui/icons-material/Person";

const App = () => (
	<Admin
		dataProvider={jsonServerProvider("/api")}
		authProvider={authProvider}
		loginPage={LoginPage}
		theme={NyuTheme}
		layout={Layout}
		requireAuth
		disableTelemetry
	>
		<Resource
			name="missions"
			icon={MonitorHeartIcon}
			list={MissionList}
			create={MissionCreate}
			show={MissionShow}
		/>
		<Resource
			name="organs"
			icon={FavoriteIcon}
			list={OrganList}
			create={OrganCreate}
			show={OrganShow}
			edit={OrganEdit}
		/>
		<Resource
			name="teams"
			icon={GroupsIcon}
			list={TeamList}
			show={TeamShow}
			edit={TeamEdit}
			create={TeamCreate}
		/>
		<Resource
			name="users"
			icon={PersonIcon}
			list={UserList}
			create={UserCreate}
			show={UserShow}
			edit={UserEdit}
		/>
		<Resource name="team-users" create={TeamUserCreate} />
		<Resource name="organ-teams" create={OrganTeamCreate} />
		<Resource
			name="channels"
			create={ChannelCreate}
			show={ChannelShow}
			edit={ChannelEdit}
		/>
		<Resource
			name="organ-events"
			create={OrganEventCreate}
			edit={OrganEventEdit}
		/>
		<CustomRoutes>
			<Route path="/logout" element={<LogoutPage />} />
			<Route path="/analytics" element={<AnalyticsDashboard />} />
		</CustomRoutes>
	</Admin>
);

export default App;
